// The station normal of a polyline (perps) — ONE rule for every consumer
// that frames a way across its stations: world/corridor.js (lane cross-fall),
// world/flights.js and world/emit.js (station normals), the gates
// (scripts/check-ways.mjs, scripts/check-emit.mjs); game/waysdraw.js draws
// on the same rule. Dependency-free CommonJS.
'use strict';

// averaged left-perpendicular per point.
// At hairpins the averaged direction collapses to ~0 and the perpendicular
// flips arbitrarily, turning the strip into a bowtie sliver — reuse the
// previous point's frame there.
function perps(pts) {
  const out = [];
  for (let i = 0; i < pts.length; i++) {
    const q = pts[Math.min(pts.length - 1, i + 1)];
    const o = pts[Math.max(0, i - 1)];
    const dx = q[0] - o[0], dz = q[2] - o[2];
    const len = Math.hypot(dx, dz);
    if (len < 0.5 && out.length) {
      out.push(out[out.length - 1]);
      continue;
    }
    const l = len || 1;
    out.push([-dz / l, dx / l, dx / l, dz / l]);  // px, pz, ux, uz
  }
  return out;
}

module.exports = { perps };
